import { createGlobalStyle } from 'styled-components';
import 'react-tippy/dist/tippy.css';
import { ATHENS_GRAY, VERY_LIGHT_GREY } from 'common/constants/colors';

/* eslint no-unused-expressions: 0 */
createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body.fontLoaded {
    font-family: Helvetica;
  }

  #app {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    line-height: 1.5em;
  }

  input[type="text"], input[type="number"] {
    padding: 5px 10px;
    border: 1px solid ${VERY_LIGHT_GREY};
    margin-bottom: 5px;
    background: ${ATHENS_GRAY};
  }
`;
